export const BrandCompetitorsType = {
  OWNED: 'OWNED',
  INDEPENDENT: 'INDEPENDENT',
  OWNER: 'OWNER',
} as const;

export const CompetitorTypeOption = {
  BrandOwners: { value: 'BrandOwners', label: 'brand owners' },
  Brands: { value: 'Brands', label: 'brands' },
};

export const AddCompetitorLabel = {
  [CompetitorTypeOption.BrandOwners.value]: 'Add brand owner',
  [CompetitorTypeOption.Brands.value]: 'Add brand',
};

export const CompetitorRadioOptions = {
  TopN: 'topNBrandsOrBrandOwners',
  ExactList: 'exactList',
};

export const CompetitorCheckBoxOptions = {
  TopN: 'topNBrandsOrBrandOwners',
  ExactList: 'exactList',
};

export const BrandCompetitorOptions = {
  TopBrandOwners: 'topBrandOwners',
  TopBrands: 'topBrands',
  ExactList: 'exactList',
};

export const BrandType = {
  BrandOwnerName: 'brand_owner_name',
  BrandName: 'brand_name',
};

export const BrandCompetitorTypeOptionMap = {
  [BrandType.BrandName]: CompetitorTypeOption.Brands,
  [BrandType.BrandOwnerName]: CompetitorTypeOption.BrandOwners,
};

export const BrandTypeMap = {
  BrandOwners: BrandType.BrandOwnerName,
  Brands: BrandType.BrandName,
};

export const BrandsContextKeys = {
  BrandLimitingOptionsKey: 'brandLimitingOptions',
  HighlightedBrandKey: 'highlightedBrand',
  CompetitorBrandOptionKey: 'competitorBrandOption',
  CompetitorBrandListKey: 'competitorBrandList',
  BrandCompetitorCategoryKey: 'brandCompetitorCategory',
  TopNSelectionKey: 'topNSelection',
  TopValueOptionsKey: 'topValueOptions',
  QuantityTypeOptionsKey: 'quantityTypeOptions',
  BrandCompetitorTypeKey: 'brand_competitor_type',
} as const;

export const BrandsContextKeyValues = Object.values(BrandsContextKeys);

export const BrandsContextKeysList = Object.keys(BrandsContextKeys) as Array<keyof typeof BrandsContextKeys>;

export const mobileViewportHeight = 'calc(100vh - 78px)';
